module.exports = __webpack_public_path__ + "static/media/header-img.fb49b5ce.jpg";